import axios from 'axios'
import qs from 'qs'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getToken } from '@/utils/auth'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 15000,
  paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
})

function cleanParams(params) {
  if (!params) return params
  return Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v !== '' && v != null)
  )
}


service.interceptors.request.use(config => {
  const token = getToken()
  if (token) {
    config.headers['Authorization'] = token
  }

  // ✅ auto-clean query params
  if (config.params) {
    config.params = cleanParams(config.params)
  }

  return config
}, error => {
  return Promise.reject(error)
})

service.interceptors.response.use(
  response => {
    if (response.data instanceof Blob) {
      return response.data
    }
    if (response.data.code !== 200) {
      ElMessage({
        message: response.data.message,
        type: 'error',
        duration: 3000
      })
      return Promise.reject(response.data.message)
    }
    return response.data
  },
  error => {
    if (error.response?.status === 401) {
      ElMessageBox.confirm(
        'You have been logged out. Please log in again.',
        'Session Expired',
        {
          confirmButtonText: 'Log In Again',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      ).then(() => {
        // Lazy import to avoid circular dependency
        import('@/stores/user').then(({ useUserStore }) => {
          useUserStore().FedLogOut().then(() => location.reload())
        })
      })
      return Promise.reject('unauthorized')
    }

    if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
      ElMessage({ message: 'Request timed out. Please try again.', type: 'error', duration: 3000 })
      return Promise.reject(new Error('Request timed out.'))
    }

    ElMessage({
      message: error.message || 'Network error',
      type: 'error',
      duration: 3000
    })
    return Promise.reject(error)
  }
)

export default service
